/* Static reviews with explicit collection and full-quote disclosure. */
(() => {
 const initialise = root => {
  if (root.dataset.mpGoogleReady === 'true') return;
  const cards = [...root.querySelectorAll('.mp-google-card')];
  const more = root.querySelector('[data-mp-google-more]');
  if (!cards.length || !more) return;
  root.dataset.mpGoogleReady = 'true';
  root.classList.add('is-ready');
  const preferred = ['This is by far my favourite.', 'the food is delicious.', '10/10 would recommend!'];
  cards.forEach((card, index) => {
   const quote = card.querySelector('.mp-google-card__quote');
   const toggle = card.querySelector('[data-mp-google-toggle]');
   const original = quote.textContent.replace(/^[“”]|[“”]$/g, '').trim();
   const sentences = original.match(/[^.!?]+[.!?]+|[^.!?]+$/g) || [original];
   const candidate = sentences.map(s => s.trim()).find(s => s.length >= 15 && s.length <= 110) || original.split(/\s+/).slice(0,16).join(' ') + '…';
   const excerpt = preferred[index] && original.includes(preferred[index]) ? preferred[index] : candidate;
   const preview = document.createElement('p');
   preview.className = 'mp-google-card__excerpt';
   preview.textContent = '“' + excerpt + '”';
   quote.before(preview);
   toggle.hidden = false;
   toggle.addEventListener('click', () => {
    const expanded = card.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.textContent = expanded ? 'Show less' : 'Read full review';
   });
   if (index > 2) card.hidden = true;
  });
  more.hidden = cards.length <= 3;
  more.addEventListener('click', () => {
   const expanded = more.getAttribute('aria-expanded') !== 'true';
   more.setAttribute('aria-expanded', String(expanded));
   more.textContent = expanded ? 'Show fewer reviews' : 'Show more reviews';
   cards.slice(3).forEach(card => { card.hidden = !expanded; });
  });
 };
 const all = scope => scope.querySelectorAll('[data-mp-home-google]').forEach(initialise);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => all(document), {once:true});
 else all(document);
 document.addEventListener('shopify:section:load', event => all(event.target));
})();
